import { Icon, IconButton, Modal } from "materia"
import type { PropsWithChildren, ReactNode } from "react"
import s from "./VppModal.module.scss"

export const VppModal = ({
  children,
  onClose,
}: {
  children: ReactNode
  onClose: () => void
}) => (
  <Modal onClose={onClose} ariaLabel="App store country">
    <div className={s.content}>{children}</div>
  </Modal>
)

type HeaderProps = {
  title: string
  onClose: () => void
}
const Header = ({ title, onClose }: HeaderProps) => (
  <header className={s.header}>
    <div className={s.header__title}>{title}</div>
    <IconButton as="button" icon="Close" onClick={onClose} aria-label="Close" />
  </header>
)

type BodyTextProps = {
  text: string
}
const BodyText = ({ text }: BodyTextProps) => (
  <div className={s.bodyText}>{text}</div>
)

const Countries = ({ children }: PropsWithChildren) => (
  <ul className={s.countries}>{children}</ul>
)

type CountryProps = {
  title: string
  onClick: () => void
}
const Country = ({ title, onClick }: CountryProps) => (
  <li className={s.country}>
    <button className={s.country__button} onClick={onClick}>
      <div className={s.country__title}>{title}</div>
      <Icon icon="Arrow" className={s.country__arrow} />
    </button>
  </li>
)

VppModal.Header = Header
VppModal.BodyText = BodyText
VppModal.Countries = Countries
VppModal.Country = Country
